import { PlayCircleFilledTwoTone as PlayButton } from '@mui/icons-material';
import { NETWORK_IDS, POST_TYPES } from 'lib/constants';
import { Post } from 'lib/types';
import { PostCaption } from 'components/PostCaption';
import YouTube from 'react-youtube';
import { getYoutubeVideoId, truncate } from 'lib/helpers';

/*
The instagram api will 400 an entire request instead of making thumbnail url an optional field.
It prevents our previous instaurl/media?=l workaround. But does allow a direct link to the video.

So if we have a video link go ahead and give the user some visual info by using the video tag
so we can show them the first frame of the vid.
 */
interface Props {
  post: Post;
  maxTextLength?: number;
}

export const PostContent = ({ post, maxTextLength }: Props) => {
  const date = new Date(post.postedAt);
  if (!post.thumbnailUrl && !post.videoUrl) {
    return (
      <div className="w-full bg-hintgray dark:bg-darkgray p-2">
        <span className="flex flex-row-reverse ml-8 text-black dark:text-white font-bold text-sm rounded-lg">
          {date.toLocaleDateString()}
        </span>
        <PostCaption networkId={post.network}>
          {truncate(post.caption, maxTextLength || 1000)}
        </PostCaption>
      </div>
    );
  }

  if (post.network === NETWORK_IDS.youtube) {
    return (
      <YouTube
        videoId={getYoutubeVideoId(post.url)}
        containerClassName="youtubeContainer"
        opts={{ width: '100%' }}
      />
    );
  }

  // Importing the constant gives a crazy can't import fs error
  if (post.type === POST_TYPES.VIDEO && !!post.videoUrl
    && post.network !== NETWORK_IDS.twitter
    && post.network !== NETWORK_IDS.tiktok
    && post.network !== NETWORK_IDS.youtube
    && post.network !== NETWORK_IDS.twitch) {
    return (
      <div className="relative">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video className="w-full" src={post.videoUrl} disablePictureInPicture controls />
        <span className="absolute top-1 right-1 text-black dark:text-white font-bold text-sm bg-white dark:bg-appbg-dark px-1 rounded-lg">
          {date.toLocaleDateString()}
        </span>
      </div>
    );
  }
  return (
    <div className="relative">
      <img src={post.thumbnailUrl} className="w-full" alt="post content" />
      <span className="absolute top-1 right-1 text-black dark:text-white font-bold text-sm bg-white dark:bg-appbg-dark px-1 rounded-lg">
        {date.toLocaleDateString()}
      </span>
      {post.type === POST_TYPES.VIDEO && <PlayButton fontSize="large" className="absolute bottom-1 left-1 text-white" />}
    </div>
  );
};
